import React from 'react';

import { IPage } from '../../../types/contentful';

import { PageProps } from '../../context/PageData';

import { Body } from '../Body';
import { HeroBlock } from './HeroBlock';
import { PageBlocks } from './PageBlocks';
import BlogPostFeed from '../BlogComponents/BlogPostFeed';

export default function Page({ pageData, base }: PageProps) {
  const { fields } = (pageData as IPage) ?? {};

  return fields ? (
    <Body {...fields}>
      <HeroBlock {...fields} />
      {base === 'blog' ? <BlogPostFeed /> : <PageBlocks {...fields} />}
    </Body>
  ) : (
    <div />
  );
}
